export default __webpack_public_path__ + "static/media/General's Legguards of the Battlements.656f2ee3.jpg";